import { styled } from "@mui/material";

export const TabPanel = styled("div")`
  --scroll-shadow-background-color: rgb(249 249 249);
  overflow-y: auto;
  max-height: 100%;
  margin-right: -3rem; // negative margin to compensate for the padding of the parent container
  padding-right: 3rem;
`;
